import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, FormikForm, SubmitButton, TextField } from '@a-type/ui';
import { ColorPicker } from './ColorPicker.js';
export function TagCreateForm({ onCreate, className, defaultColor, }) {
    return (_jsx(FormikForm, { initialValues: {
            name: '',
            color: undefined,
            icon: undefined,
        }, onSubmit: async (values, bag) => {
            await onCreate(Object.assign(Object.assign({}, values), { name: values.name.trim().toLowerCase() }));
            bag.resetForm();
        }, className: className, children: ({ setFieldValue, values }) => {
            var _a, _b;
            return (_jsxs(_Fragment, { children: [_jsxs(Box, { gap: true, items: "end", full: "width", children: [_jsx(TextField, { name: "name", label: "New tag", style: { flex: '1 0 0' } }), _jsx(Box, { style: { flexBasis: 'auto' }, children: _jsx(ColorPicker, { onValueChange: (v) => setFieldValue('color', v), value: (_b = (_a = values.color) !== null && _a !== void 0 ? _a : defaultColor) !== null && _b !== void 0 ? _b : null }) })] }), _jsx(Box, { justify: "end", full: "width", children: _jsx(SubmitButton, { emphasis: "light", type: "submit", children: "Create" }) })] }));
        } }));
}
//# sourceMappingURL=TagCreateForm.js.map